import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBoxTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
  marginBottom: theme.spacing(4),
}))
